module.exports = new __parcel__URL__("desc_4.329769e0.png").toString();